export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }